<template>
  <ul class="point-info-list">
    <li>
      <span>经度</span>：
      <span>{{ (info && info.lon) || '-' }}</span>
    </li>
    <li>
      <span>纬度</span>：
      <span>{{ (info && info.lat) || '-' }}</span>
    </li>
    <li>
      <span>高度</span>：
      <span>{{ (datasetHeight) || '-' }}</span>
    </li>
    <li>
      <span>海拔</span>：
      <span>{{ (info && info.altitude) || '-' }}</span>
    </li>
    <li>
      <span>空气密度</span>：
      <span>{{ (info && info.rhoair) || '-' }}</span>
    </li>
    <li>
      <span>平均风速</span>：
      <span>{{ (info && info.windSpeed) || '-' }}</span>
    </li>
    <li>
      <span>平均气温</span>：
      <span>{{ (info && info.powerDensity) || '-' }}</span>
    </li>
    <li>
      <span>风切变</span>：
      <span>{{ (info && info.shearExp) || '-' }}</span>
    </li>
    <li>
      <span>A值</span>：
      <span>{{ (info && info.weibullA) || '-' }}</span>
    </li>
    <li>
      <span>K值</span>：
      <span>{{ (info && info.weibullK) || '-' }}</span>
    </li>
  </ul>
</template>
<script>
export default {
  props: {
    info: {
      type: Object,
    },
    datasetHeight: Number,
  },
};
</script>

<style lang="less" scoped>
.point-info-list {
  padding: 10px;
  width: 420px;
  float: left;
  li {
    width: 200px;
    color: #fff;
    font-size: 14px;
    float: left;
    display: inline-block;
    justify-content: space-between;
    padding: 5px;
  }

  span{
      width: 75px;
      display: inline-block;
    }

  .el-input {
    margin-left: 40px;
    flex: 1;
  }
}
</style>